import React from 'react';
import { ErrorBoundary } from '@mrkt/features/Platform';

import { DialogFullScreen } from './components/DialogFullScreen';
import { useFundraisingWizard } from './lib/useFundraisingWizard';

function FundraisingWizardForm() {
  const {
    dialogBody,
    dialogBodyTitle,
    dialogFooter,
    dialogNavStepper,
    dialogOnClose,
    dialogOnEscape,
    dialogTitle,
  } = useFundraisingWizard();

  return (
    <DialogFullScreen
      onClose={dialogOnClose}
      onEscape={dialogOnEscape}
      navStepper={dialogNavStepper}
      dialogTitle={dialogTitle}
      bodyTitle={dialogBodyTitle}
      body={dialogBody}
      footer={dialogFooter}
    />
  );
}

export function FundraisingForm() {
  return (
    <ErrorBoundary fallback={null} name="artist-fundraising-pick">
      <FundraisingWizardForm />
    </ErrorBoundary>
  );
}
